import { render, staticRenderFns } from "./SubDirektorat.vue?vue&type=template&id=7b93ab9e"
import script from "./SubDirektorat.vue?vue&type=script&lang=js"
export * from "./SubDirektorat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports